<script setup>
const props = defineProps({
  cards: {
    type: Array,
    default: () => [],
  },
})
</script>

<template>
  <div class="financial-cards">
    <article v-for="card in cards" :key="card.key" class="card" :class="card.tone ? `tone-${card.tone}` : ''">
      <h3>{{ card.label }}</h3>
      <p>{{ card.value }}</p>
      <small v-if="card.hint">{{ card.hint }}</small>
    </article>
  </div>
</template>

<style scoped>
.financial-cards { display: grid; gap: 0.65rem; grid-template-columns: repeat(auto-fit, minmax(160px, 1fr)); }
.card { border: 1px solid #e5e7eb; border-radius: 8px; padding: 0.65rem; background: #fff; }
.tone-success { border-color: #86efac; background: #f0fdf4; }
.tone-warning { border-color: #fcd34d; background: #fffbeb; }
.tone-info { border-color: #93c5fd; background: #eff6ff; }
</style>

